<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <el-card class="box-card">
        <el-form
          :inline="true"
          :model="searchFormObj"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item
            label="商品名称"
            class="inline-form-item form-item-margin"
          >
            <el-input
              v-model="searchFormObj.good_name"
              clearable
              placeholder=""
            />
          </el-form-item>
          <el-form-item
            label="订单编号"
            class="inline-form-item form-item-margin"
          >
            <el-input
              v-model="searchFormObj.order_no"
              clearable
              placeholder=""
            />
          </el-form-item>
          <el-form-item
            label="收益类型"
            class="inline-form-item form-item-margin"
          >
            <el-select
              v-model="searchFormObj.income_type"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="推广者姓名"
            class="inline-form-item form-item-margin"
          >
            <el-autocomplete
              class="inline-input"
              v-model="searchFormObj.promoter_fullname"
              :fetch-suggestions="querySearch"
              placeholder="可模糊查询和下拉查询"
              clearable
              @select="handleNameSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="付款时间：" class="inline-form-item">
            <el-date-picker
              v-model="timeArr"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item
            label="收益状态"
            class="inline-form-item form-item-margin"
          >
            <el-select
              v-model="searchFormObj.status"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item class="inline-form-item form-item-margin">
            <!-- <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSearchSubmit"
            >搜索</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-refresh"
            @click="onSearchEmptySubmit"
            >重置</el-button
          > -->
            <MyButton
              value="搜索"
              size="medium"
              icon="el-icon-search"
              type="1"
              @click="onSearchSubmit"
            ></MyButton>
            <MyButton
              value="重置"
              size="medium"
              type="2"
              @click="onSearchEmptySubmit"
            ></MyButton>
          </el-form-item>
        </el-form>
      </el-card>

      <div class="table_box">
        <el-table
          v-loading="isLoading"
          :data="teachTableDataArr"
          style="width: 100%"
          border
          size="mini"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="id" label="ID" align="center" />
          <el-table-column
            prop="income_type"
            label="收益类型"
            align="center"
            :render-header="renderHeaderType"
          >
            <template slot-scope="scope">
              {{ incomeTypeMap.get(scope.row.income_type) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="promoter_fullname"
            label="推广者姓名"
            align="center"
          />
          <el-table-column prop="good_name" label="商品名称" align="center" />
          <el-table-column prop="created_at" label="付款时间" align="center" />
          <el-table-column prop="order_no" label="订单编号" align="center" />
          <el-table-column prop="fee" label="成交金额" align="center" />
          <el-table-column prop="cb_good_price" label="成本价" align="center" />
          <el-table-column
            prop="group_tc_money"
            label="收益金额"
            align="center"
            :render-header="renderHeaderMoney"
          />
          <el-table-column
            prop="tc_money"
            label="老师/员工提成"
            align="center"
            :render-header="renderHeaderGet"
          />

          <el-table-column
            prop="status"
            label="收益状态"
            align="center"
            :render-header="statusHeaderGet"
          >
            <template slot-scope="scope">
              {{ statusMap.get(scope.row.status) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="money-box">
        <!-- 共计收益金额 <span>{{ total_income_money }}</span
        >，老师/员工提成 <span>{{ total_tc_money }}</span> -->

        收益订单总数：<span>{{ order_total }}</span
        >， 订单实付总金额：<span>￥{{ fee }}</span
        >， 退款订单金额：<span>￥{{ refund_fee }}</span
        >， 机构分成收益总金额：<span>￥{{ total_income_money }}</span
        >， 老师/员工提成：<span>￥{{ total_tc_money }}</span>
      </div>

      <div class="page_box">
        <el-pagination
          :current-page="searchFormObj.page"
          background
          :page-sizes="[10, 20, 30, 50]"
          :page-size="searchFormObj.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import recruitStudentApi from "@/api/recruitStudent";
import commonApi from "@/api/common";
import { deepClone } from "@/utils";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "institutionalIncomeDetail",
  components: {
    MyButton,
  },
  data() {
    return {
      searchFormObj: {
        good_name: "", // 商品名称
        order_no: "", // 订单编号
        promoter_fullname: "", // 推广者姓名
        income_type: 0, // 收益类型
        limit: 20,
        page: 1,
        status: 0,
      }, // 搜索数据
      timeArr: [], // 加入时间数组
      isLoading: false, // 表单加载状态
      total: 0, // 数据总数
      typeTip: "", // 收益类型提示
      MoneyTip: "", // 收益金额提示
      getTip: "", // 提成提示
      teachTableDataArr: [], // 老师表单数据
      incomeTypeOptions: [
        { value: 1, label: "自推" },
        { value: 2, label: "员工推广" },
        { value: 3, label: "老师推广" },
      ],
      typeOptions: [
        { value: 0, label: "全部" },
        { value: 1, label: "自推（直接收益）" },
        { value: 2, label: "员工推广（间接收益）" },
        { value: 3, label: "老师推广（间接收益）" },
      ],
      nameList: [], // 姓名列表
      total_income_money: "", // 总收益（元）
      total_tc_money: "", // 总提成（元）
      statusOptions: [
        { value: 0, label: "全部" },
        // { value: 1, label: "冻结中" },
        { value: 2, label: "待结算" },
        { value: 3, label: "可结算" },
        { value: 4, label: "已结算" },
        { value: 5, label: "已失效" },
      ],
      getStatus: "", //收益状态提示
      order_total: "",
      fee: "",
      refund_fee: "",
    };
  },
  created() {
    // 获取问号中的显示内容
    this.getDic();
    this.getList();
    this.getNameList();
  },
  computed: {
    incomeTypeMap() {
      return new Map(
        this.incomeTypeOptions.map((item) => [item.value, item.label])
      );
    },
    statusMap() {
      return new Map(
        this.statusOptions.map((item) => [item.value, item.label])
      );
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 == 0) {
        return "warning-row-color";
      }
      return "";
    },
    // 提交搜索表单
    onSearchSubmit() {
      console.log("搜索");
      this.searchFormObj.page = 1;
      this.getList();
    },
    // 重置表单
    onSearchEmptySubmit() {
      console.log("重置");
      this.searchFormObj = {
        good_name: "", // 商品名称
        order_no: "", // 订单编号
        promoter_fullname: "", // 推广者姓名
        income_type: 0, // 收益类型
        limit: 20,
        page: 1,
      };
      this.timeArr = [];
      this.getList();
    },
    // 每页尺寸改变函数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchFormObj.limit = val;
      this.searchFormObj.page = 1;
      this.getList();
    },
    // 页码改变函数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchFormObj.page = val;
      this.getList();
    },
    // 获取表单数据函数
    getList() {
      console.log("表单提交");
      this.isLoading = true;
      const query = deepClone(this.searchFormObj);
      console.log("timeArr", this.timeArr);
      if (this.timeArr && this.timeArr.length == 2) {
        query.start_time = this.timeArr[0];
        query.end_time = this.timeArr[1];
      }
      console.log("query", query);

      recruitStudentApi.incomeList(query).then((res) => {
        if (res.code === 200) {
          this.teachTableDataArr = res.data.data;
          this.total = res.data.total;
          this.total_income_money = res.data.total_income_money;
          this.total_tc_money = res.data.total_tc_money;
          this.order_total = res.data.order_total;
          this.fee = res.data.fee;
          this.refund_fee = res.data.refund_fee;
          this.isLoading = false;
        }
      });
    },
    // 获取问号中的显示内容
    getDic() {
      commonApi.getInfoToName({ name: "bktzkbzkbText" }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            // 收益类型提示
            if (item.key === "jgsylxsm_text") {
              this.typeTip = item.value;
            } else if (item.key === "syje_text") {
              // 收益金额提示
              this.MoneyTip = item.value;
            } else if (item.key === "ssygtc_text") {
              // 提成提示
              this.getTip = item.value;
            }
          });
        }
      });
      commonApi.getInfoToName({ name: "nailingreminder" }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            // 收益类型提示
            if (item.key === "revenuestatus") {
              this.getStatus = item.value;
            }
          });
        }
      });
    },
    // 收益类型表头
    renderHeaderType(h, { column }) {
      // console.log('修改表头   slot="reference" style="margin-left: 30px"
      return h("span", [
        h("span", column.label),
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-left:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.typeTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
      ]);
    },
    // 收益金额表头 renderHeaderGet
    renderHeaderMoney(h, { column }) {
      // console.log('修改表头   slot="reference" style="margin-left: 30px"
      return h(
        "div",
        {
          style: "display: flex;justify-content: center;align-items: center;",
        },
        [
          h(
            "div",
            {
              style:
                "display: flex;justify-content: center;align-items: center;flex-direction: column;",
            },
            [
              h("span", column.label),
              h(
                "span",
                { style: "font-size: 2px; !important" },
                "（含老师/员工提成部分）"
              ),
            ]
          ),
          h(
            "el-popover",
            {
              props: {
                placement: "top-start",
                width: "200",
                trigger: "hover",
              },
            },
            [
              h("i", {
                class: "el-icon-question el-icon--right",
                style: "margin-left:5px;cursor:pointer;",
                slot: "reference",
              }),
              h("div", {
                domProps: {
                  innerHTML: this.MoneyTip, // 这里是要渲染的数据
                },
                style: "white-space: pre-line;",
              }),
            ]
          ),
        ]
      );
    },
    // 老师/员工提成表头
    renderHeaderGet(h, { column }) {
      // console.log('修改表头   slot="reference" style="margin-left: 30px"
      return h("span", [
        h("span", column.label),
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-left:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.getTip, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
      ]);
    },
    statusHeaderGet(h, { column }) {
      // console.log('修改表头   slot="reference" style="margin-left: 30px"
      return h("span", [
        h("span", column.label),
        h(
          "el-popover",
          {
            props: {
              placement: "top-start",
              width: "200",
              trigger: "hover",
            },
          },
          [
            h("i", {
              class: "el-icon-question el-icon--right",
              style: "margin-left:5px;cursor:pointer;",
              slot: "reference",
            }),
            h("div", {
              domProps: {
                innerHTML: this.getStatus, // 这里是要渲染的数据
              },
              style: "white-space: pre-line;",
            }),
          ]
        ),
      ]);
    },

    // 姓名列表
    getNameList() {
      recruitStudentApi.promoterUsers().then((res) => {
        if (res.code == 200) {
          this.nameList = res.data.data.map((item) => {
            return { value: item.realname };
          });
        }
      });
    },
    // 姓名查询选项获取函数
    querySearch(queryString, cb) {
      cb(this.nameList);
    },
    // 姓名选择函数
    handleNameSelect(item) {
      console.log("选择姓名", item);
      this.searchFormObj.promoter_fullname = item.value;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .box-card {
  padding: 20px 12px 0 12px;
  /deep/ .el-card__body {
    padding: 20px 0px;
  }
  /deep/ .el-form-item {
    margin-right: 0;
    .el-button {
      margin-left: 20px;
    }
  }
}
.form-item-margin {
  margin-left: 20px;
}
.table_box {
  margin-top: 20px;
}
.page_box {
  margin-top: 20px;
}
.money-box {
  text-align: end;
  margin-top: 12px;
  font-size: 16px;
  span {
    color: #d9001b;
  }
}
</style>
